import React from 'react'
import { Box, Button, Grid} from '@mui/material'
import buttonStyle from '../../../styles/buttonStyle'
import { useNavigate } from 'react-router-dom';
import ArrowBackOutlinedIcon from '@mui/icons-material/ArrowBackOutlined';
import AddPartsTable from '../../../components/estimate/AddPartsTable';

function AddParts() {
    const navigate = useNavigate()

    return (
        <Box mt={2}>
            <Grid container spacing={1}>
                <Grid item xs={12} display='flex' justifyContent='flex-end'>
                    <Button sx={buttonStyle.root} onClick={() => navigate('/add_estimate')}><ArrowBackOutlinedIcon />Back</Button>
                </Grid>
                <Grid item xs={12} mt={1}>
                    <AddPartsTable/>
                </Grid>
            </Grid>
        </Box>
    )
}

export default AddParts